import React from 'react'
import Photo02 from '../assets/Design.png'

const BarTWO = () => {
    return (
        <div className='flex flex-wrap justify-between  shadow-3xl'>
            <div className='mx-auto lg:mx-40'>
                <div className='lg:flex items-center'>
                    <img className='w-32 Photo02Style' src={Photo02} alt='arteDeImpactar' />
                    <h1 className=' px-5 headerNameStyle'>PALOMA PATRICIA</h1>
                </div>                   
                              
            </div>
           
        </div>
    )
}
export default BarTWO